


































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { showErrors } from '@/utils/snack'
import AppDialog from '@/components/AppDialog.vue'
import { parsePhoneNumber, parsePhoneNumberReturnInfo } from '@/utils/phoneNumberFormat'
import { searchAccountsAndContacts } from '@/modules/PhoneLog/gql/phone.gql'
import { ApolloResponse } from '@/interfaces/apollo'

@Component({
  components: {
    AppDialog
  }
})
export default class CallerDialog extends Vue {
  @Prop(Boolean) value!: boolean
  @Prop(String) readonly phone!: string
  @Prop(Number) readonly step!: number

  showDialog = false
  dialogLoading = false
  accountList: any[] = []

  accountTableColumn = [
    { field: 'accountName', title: 'Account Name', slots: { default: 'account_name_default' }, resizable: true },
    { field: 'accountPhone', title: 'Account Phone', slots: { default: 'account_phone_default' }, resizable: true },
    { field: 'contactName', title: 'Contact Name', slots: { default: 'contact_name_default' }, resizable: true },
    { field: 'contactPhone', title: 'Contact Phone', slots: { default: 'contact_phone_default' }, fixed: 'right' }
  ]

  parsePhoneNumber = parsePhoneNumber

  @Watch('value')
  onValueChanged (val: boolean) {
    if (val) {
      this.searchAccountsAndContacts()
    }
    this.showDialog = val
  }

  async searchAccountsAndContacts () {
    const that = this
    if (!this.phone) {
      return
    }
    this.dialogLoading = true
    const phoneVal = parsePhoneNumberReturnInfo(this.phone)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: searchAccountsAndContacts,
        variables: {
          countryCallingCode: phoneVal['countryCallingCode'],
          phone: phoneVal['phone']
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      const list: any[] = []
      if (result.data.searchAccountsAndContacts.accounts) {
        for (var i = 0; i < result.data.searchAccountsAndContacts.accounts.length; i++) {
          const item = {
            accountId: result.data.searchAccountsAndContacts.accounts[i].id,
            accountName: result.data.searchAccountsAndContacts.accounts[i].name,
            accountPhone: that.phone,
            contactId: null,
            contactName: '',
            contactPhone: ''
          }
          list.push(item)
        }
      }
      if (result.data.searchAccountsAndContacts.contacts) {
        for (var m = 0; m < result.data.searchAccountsAndContacts.contacts.length; m++) {
          if (result.data.searchAccountsAndContacts.contacts[m].accounts) {
            for (var n = 0; n < result.data.searchAccountsAndContacts.contacts[m].accounts.length; n++) {
              const item = {
                accountId: result.data.searchAccountsAndContacts.contacts[m].accounts[n].id,
                accountName: result.data.searchAccountsAndContacts.contacts[m].accounts[n].name,
                accountPhone: '',
                contactId: result.data.searchAccountsAndContacts.contacts[m].contact.id,
                contactName: result.data.searchAccountsAndContacts.contacts[m].contact.name,
                contactPhone: that.phone
              }
              list.push(item)
            }
          } else {
            const item = {
              accountId: null,
              accountName: '',
              accountPhone: '',
              contactId: result.data.searchAccountsAndContacts.contacts[m].contact.id,
              contactName: result.data.searchAccountsAndContacts.contacts[m].contact.name,
              contactPhone: that.phone
            }
            list.push(item)
          }
        }
      }
      this.dialogLoading = false
      this.accountList = list.concat()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  routeToAccountDetail (item: any) {
    return {
      name: 'AccountDetailDetail',
      params: {
        id: item.accountId
      }
    }
  }

  routeToContactDetail (item: any) {
    return {
      name: 'ContactDetailDetail',
      params: {
        id: item.contactId
      }
    }
  }

  @Emit('cancel')
  handleCancel () {}
}
